// extracted by mini-css-extract-plugin
module.exports = {"roomCard":"RoomCard_roomCard__2D6XO","cardImage":"RoomCard_cardImage__bfOa_"};